<template>
  <div class="winnerContainer pointer" :class="{display: hasWinnerInfo && showWinner}">
    <img :src="cancel" alt="" @click="setShowWinner(false)">
    <div class="winnerContent" v-if="hasWinnerInfo && showWinner" @click="fetchGame(winnerInfo)">
      <div class="img">
        <img :src="winnerInfo.ThumbnailUrl" alt="">
        <div class="imgMask"/>
      </div>
      <div class="winner">
        <div class="game">{{winnerInfo.GameNameEn}}</div>
        <div>
          {{winnerInfo.UserName.substr(0, 4)}}**** {{$t('lang.winner.justWon')}} {{fetchCurrencyByCulture[winnerInfo.Culture]}}{{formatNum(winnerInfo.Amount)}} {{$t('lang.winner.playing')}} {{winnerInfo.GameNameEn}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cancel from '@/assets/images/common/cancel_black.svg'
import request from '@/service'
import {separateThousand} from '@/utils'
import {fetchCurrencyByCulture} from '@/constant'
import {mapMutations} from 'vuex'
export default {
  name: 'Winner',
  data () {
    return {
      cancel,
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      showWinner: true,
      winnerInfo: {},
      fetchCurrencyByCulture,
      gameInfo: {
        showIframe: true,
        gameName: '',
        gameUrl: ''
      },
      hasWinnerInfo: false // 先判断是否有winner信息，然后判断showWinner，决定是否弹出Winner组件。（解决个别浏览器弹出空winner信息的情况，以及避免在页面mount时winnerInfo为undefined时执行winnerInfo.UserName.substr） By HHY 20220602
    }
  },
  computed: {
    formatNum () {
      return (val) => {
        return this.separateThousand(val)
      }
    }
  },
  mounted () {
    const rdm = Math.random()
    setInterval(() => {
      this.fetchWinners()
    }, (rdm + 3) * 10000)
  },
  methods: {
    ...mapMutations({
      setShowWinner: 'setShowWinner',
      setGameInfo: 'setGameInfo'
    }),
    separateThousand,
    fetchWinners (num) {
      request('post', '/innovation/home/getrealtimewinners', {
        Number: num || 1,
        Culture: 'id'
        // Culture: localStorage.getItem('locale')
      }, true).then(res => {
        this.winnerInfo = res.Winners[0]
        this.hasWinnerInfo = this.VerifyHasWinner()
        this.showWinner = true
        this.gameInfo = {
          showIframe: true,
          gameName: this.winnerInfo.GameNameEn,
          gameUrl: this.winnerInfo.ThumbnailUrl
        }
        setTimeout(() => {
          this.showWinner = false
          this.gameInfo = {}
        }, 5000)
      })
    },
    fetchGame (game) {
      if (this.userInfo && this.$store.state.banUserId.includes(this.userInfo.UserId)) {
        this.$message.error(this.$t('lang.home.gameMaintenancePrompt'))
        return
      }
      const url = '/innovation/game/getgameurl'
      const data = {
        userId: this.userInfo.UserId || '',
        gameCode: game.GameCode,
        gameProviderId: game.GameProviderId,
        deviceWidth: 1125,
        lang: localStorage.getItem('locale')
      }
      request('post', url, data).then(res => {
        console.log(res)
        if (res.status === 401) return
        if (res.Url) {
          this.gameInfo = {
            showIframe: true,
            gameUrl: res.Url,
            gameName: game.GameNameEn
          }
          this.setGameInfo(this.gameInfo)
        } else {
          this.$message.error(this.$t('lang.home.gameMaintenancePrompt'))
        }
      })
    },
    VerifyHasWinner () {
      const flag = this.winnerInfo !== undefined && this.winnerInfo.GameNameEn.trim() !== ''
      return flag
    }
  }
}
</script>

<style lang="less" scoped>
  .winnerContainer {
    position: fixed;
    left: -500px;
    bottom: 20px;
    padding: 10px 10px 10px 12px;
    background: linear-gradient(180deg, #F6D9AA 14.52%, rgba(255, 153, 0, .3) 100%);
    border-radius: 0 13px 13px 0;
    transition: left, .3s;
    z-index: 9999;
    >img {
      position: absolute;
      width: 20px;
      top: -10px;
      right: -10px;
    }
    .winnerContent {
      display: flex;
      align-items: center;
      .img {
        position: relative;
        margin-right: 8px;
        img {
          height: 80px;
          border-radius: 6px;
        }
        .imgMask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 58.82%, #000000 90%);
          border-radius: 6px;
        }
      }
      .winner {
        font-size: 10px;
        line-height: 19px;
        color: #ffffff;
        width: 160px;
        .game {
          font-size: 15px;
          line-height: 23px;
          margin-bottom: 4px;
        }
      }
    }
  }
  .display {
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Winner/index.vue